import { render, staticRenderFns } from "./UserSignUp.vue?vue&type=template&id=18184165&"
import script from "./UserSignUp.vue?vue&type=script&lang=js&"
export * from "./UserSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports